var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 114 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AMA_Wire_xAE_",
    transform: "translate(-30.331 -42.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m130.4 68.7-2.3-5.2c-1.6 1.1-2.2 1.8-2.2 1.8l2.5 4.9c0-.1 1-.9 2-1.5",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m123.8 61.1-1.7-3.4c.8-.9 2.6-2.3 2.6-2.3l1.6 3.6c-.1 0-1.4.9-2.5 2.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m119.4 52.5-4.9-9.5h4.8l2.9 6.8v.1c.1.1-1.4 1.1-2.8 2.6",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m133.7 80.3-3.4-6.6s.7-.7 1.7-1.3l2.7 6.2c-.1 0-.6.8-1 1.7",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m135 83 3 5.8h1l-3.1-7.3s-.5.5-.9 1.5",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M141.7 77.7c-.1.1 0 0 0 0-.8.6-1.9 1.1-3.4 1.5l-.2.1s-.5.2-1.8 1.8h.1c3.4-.2 6.2-.9 7.3-1.8.1-.1.1 0 .1-.1-.3-.9-.9-1.5-2.1-1.5",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M143.7 61.8c-1.3 1.7-6.1 2.9-11.8 3.1h-2.8l-.7-1.7 1-.6h1.8c4.8-.2 7.9-1.4 9.4-2.8 0-.1 2.3.4 3.1 2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M123.1 61.8c-1.2-.3-2.4-.6-3.2-1l-.2-.1s-.7 1.1-.8 2.2l.2.1c.7.4 1.3.6 2.3.9.5-.7 1.2-1.6 1.7-2.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m133.5 80.8-.7-1.3h-.2c-2.3-.2-4.3-.6-5.5-1.2l-.1-.1c-.4 1-.2 1.4-.2 1.5h.1c1.4.7 3.8 1.2 6.6 1.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m132.3 72.2.6 1.4h.9c5 0 8.9-1 10-2.4-.9-1.4-2.5-1.6-2.8-1.6-1.3 1.1-4.1 2-7.9 2 .1.1-.2.2-.8.6",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M127.4 71.1c-2-.4-3.3-.9-4.4-1.6l-.1-.1c-.4 1-.4 1.6-.4 2l.1.1c.9.5 1.8 1 3.4 1.4.8-1.2 1-1.3 1.4-1.8",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M122.2 70.6c.4-3.3 4.1-7.2 9.3-9.6 5.5-2.5 10.7-2.3 12.3.2l.1.2c.4-1.1.5-2.3.3-3.2-1-3.7-7.1-4.3-13.6-1.3s-10.9 8.4-9.9 12.1c.2.9.8 1.6 1.5 2.1z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m144 70.8.1.1c.3-1 .4-1.9.1-2.7-.9-3-6-3.3-11.3-.7s-8.8 7.2-7.9 10.3c.2.7.7 1.3 1.3 1.7v-.3c.3-2.7 3.2-6.2 7.5-8.3 4.4-2.2 8.7-2.2 10.2-.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M144 78.7c.2-.6.3-1.3.2-2-.5-2.4-3.2-2.8-6.2-.8-3 1.9-5 5.4-4.5 7.8.1.6.3 1 .7 1.3v-.2c.2-2.1 1.9-4.7 4.2-6.3 2.5-1.6 4.9-1.5 5.6.2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M138.5 47.6s-.1-.2-.2-.5c-.1-.2-.2-.3-.2-.3-.3-.5-1.6-.5-2.8-.6-.6 0-1.8-.4-2.3-.4-.7 0-1 0-1.4.1s-1.6.6-2 .8l-.3.1c-8.6 3.2-13.9 9.7-12.6 13.7.3.9 1 1.7 2 2.3h.1c.5-3.6 5.3-8.5 12.1-11.1l.2-.1c.7-.2.6 0 1.3 0 .9 0 .9-.1 2.3-.6l3-1.1s.6-.2.9-.7c.2-.4 0-1-.1-1.6m-5.9-.1c-.8.3-1.2-.3-1.2-.3v-.1c.6-.5 1.4-.5 1.6-.6.1.6-.1.9-.4 1",
    className: "st0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M42.7 54.6h5.4L59.9 79h-5l-2.5-5.6h-14L35.8 79h-5zm7.8 14.7-5.1-10.9-5.1 10.9z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M66.3 60.5 66.2 79H62V54.6h6.4L76 72.7l7.7-18.1h6.2V79h-4.2V60.5h-.1L77.9 79h-3.8z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M104 54.6h5.4L121.2 79h-5l-2.5-5.6h-14L97.1 79h-5zm7.8 14.7-5.1-10.9-5.1 10.9z",
    className: "st0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b6cd1ddd405ed9da280b2c3f1359c119.svg";
export { ForwardRef as ReactComponent };